export default __webpack_public_path__ + "static/Global-6c9cd19f12dcc9c408cea259d7fa9e2d.jpg";